import { useState, useCallback } from "react";
import ReactBSAlert from "react-bootstrap-sweetalert";

const style = { display: "inline", marginTop: "-100px" };

function SuccessAlert({ text, title, onConfirm, onCancel }) {
  return (
    <ReactBSAlert
      success
      style={style}
      title={title}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

function ErrorAlert({
  text,
  title,
  onConfirm,
  onCancel,
  confirmBtnText = "Ok",
}) {
  return (
    <ReactBSAlert
      error
      style={style}
      title={title}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmBtnBsStyle="info"
      confirmBtnText={confirmBtnText}
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

export default function useAlert() {
  const [alert, setAlert] = useState(null);

  const closeAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const showSuccessAlert = useCallback((text, title, onConfirm, onCancel) => {
    setAlert(
      <SuccessAlert
        text={text}
        title={title}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    );
  }, []);

  const showErrorAlert = useCallback(
    (text, title, onConfirm, onCancel, confirmBtnText) => {
      setAlert(
        <ErrorAlert
          text={text}
          title={title}
          onConfirm={onConfirm}
          onCancel={onCancel}
          confirmBtnText={confirmBtnText}
        />
      );
    },
    []
  );

  return {
    alert,
    closeAlert,
    showSuccessAlert,
    showErrorAlert,
  };
}
